import { API_URL, SERVER_ERROR } from '../settings'
import { push } from 'connected-react-router'
import helpers from '../helpers'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import fetch from 'isomorphic-fetch'
import Cookies from 'universal-cookie'
import store from '../store'

var moment = require('moment')
var jwtDecode = require('jwt-decode')

export const ADMIN_LOGIN_SUCCESS = '/admin/LOGIN_SUCCESS'
export const ADMIN_LOGIN_PENDING = '/admin/LOGIN_PENDING'
export const ADMIN_AUTH_PENDING = '/admin/AUTH_PENDING'
export const ADMIN_AUTH_SUCCESS = '/admin/AUTH_SUCCESS'
export const ADMIN_FAIL = '/admin/ADMIN_FAIL'
export const ADMIN_GET_USERS_PENDING = '/admin/GET_USERS_PENDING'
export const ADMIN_GET_USERS_SUCCESS = '/admin/GET_USERS_SUCCESS'
export const ADMIN_GET_USER_PENDING = '/admin/GET_USER_PENDING'
export const ADMIN_GET_USER_SUCCESS = '/admin/GET_USER_SUCCESS'
export const ADMIN_UPDATE_USER_PENDING = '/admin/UPDATE_USER_PENDING'
export const ADMIN_UPDATE_USER_SUCCESS = '/admin/UPDATE_USER_SUCCESS'
export const ADMIN_DELETE_USER_PENDING = '/admin/DELETE_USER_PENDING'
export const ADMIN_DELETE_USER_SUCCESS = '/admin/DELETE_USER_SUCCESS'
export const ADMIN_CREATE_USER_PENDING = '/admin/CREATE_USER_PENDING'
export const ADMIN_CREATE_USER_SUCCESS = '/admin/CREATE_USER_SUCCESS'
export const ADMIN_GET_APPEALS_PENDING = '/admin/GET_APPEALS_PENDING'
export const ADMIN_GET_APPEALS_SUCCESS = '/admin/GET_APPEALS_SUCCESS'
export const ADMIN_GET_APPEAL_PENDING = '/admin/GET_APPEAL_PENDING'
export const ADMIN_GET_APPEAL_SUCCESS = '/admin/GET_APPEAL_SUCCESS'
export const ADMIN_UPDATE_APPEAL_PENDING = '/admin/ADMIN_UPDATE_APPEAL_PENDING'
export const ADMIN_UPDATE_APPEAL_SUCCESS = '/admin/ADMIN_UPDATE_APPEAL_SUCCESS'
export const ADMIN_UPDATE_APPEAL_FAIL = '/admin/ADMIN_UPDATE_APPEAL_FAIL'
export const ADMIN_UPLOAD_FILE_PENDING = '/admin/ADMIN_UPLOAD_FILE_PENDING'
export const ADMIN_UPLOAD_FILE_SUCCESS = '/admin/ADMIN_UPLOAD_FILE_SUCCESS'
export const ADMIN_UPLOAD_FILE_FAIL = '/admin/ADMIN_UPLOAD_FILE_FAIL'
export const ADMIN_GET_RESPONSES_PENDING = '/admin/GET_RESPONSES_PENDING'
export const ADMIN_GET_RESPONSES_SUCCESS = '/admin/GET_RESPONSES_SUCCESS'
export const ADMIN_GET_RESPONSE_PENDING = '/admin/GET_RESPONSE_PENDING'
export const ADMIN_GET_RESPONSE_SUCCESS = '/admin/GET_RESPONSE_SUCCESS'
export const ADMIN_UPDATE_RESPONSE_PENDING = '/admin/UPDATE_RESPONSE_PENDING'
export const ADMIN_UPDATE_RESPONSE_SUCCESS = '/admin/UPDATE_RESPONSE_SUCCESS'
export const ADMIN_DELETE_RESPONSE_PENDING = '/admin/DELETE_RESPONSE_PENDING'
export const ADMIN_DELETE_RESPONSE_SUCCESS = '/admin/DELETE_RESPONSE_SUCCESS'
export const ADMIN_CREATE_RESPONSE_PENDING = '/admin/CREATE_RESPONSE_PENDING'
export const ADMIN_CREATE_RESPONSE_SUCCESS = '/admin/CREATE_RESPONSE_SUCCESS'
export const ADMIN_CREATE_REPLY_PENDING = '/admin/CREATE_REPLY_PENDING'
export const ADMIN_CREATE_REPLY_SUCCESS = '/admin/CREATE_REPLY_SUCCESS'
export const ADMIN_TOGGLE_RESPONSE_MODAL = '/admin/TOGGLE_RESPONSE_MODAL'
export const ADMIN_UPDATE_REPLY_FIELD_VALUE = '/admin/UPDATE_REPLY_FIELD_VALUE'
export const ADMIN_CONCAT_REPLY_FIELD_VALUE = '/admin/CONCAT_REPLY_FIELD_VALUE'
export const ADMIN_UPDATE_STATUS_PENDING = '/admin/UPDATE_STATUS_PENDING'
export const ADMIN_UPDATE_STATUS_SUCCESS = '/admin/UPDATE_STATUS_SUCCESS'
export const ADMIN_GET_EMAILS_PENDING = '/admin/GET_EMAILS_PENDING'
export const ADMIN_GET_EMAILS_SUCCESS = '/admin/GET_EMAILS_SUCCESS'
export const ADMIN_GET_EMAIL_PENDING = '/admin/GET_EMAIL_PENDING'
export const ADMIN_GET_EMAIL_SUCCESS = '/admin/GET_EMAIL_SUCCESS'
export const ADMIN_UPDATE_EMAIL_PENDING = '/admin/UPDATE_EMAIL_PENDING'
export const ADMIN_UPDATE_EMAIL_SUCCESS = '/admin/UPDATE_EMAIL_SUCCESS'
export const ADMIN_DELETE_EMAIL_PENDING = '/admin/DELETE_EMAIL_PENDING'
export const ADMIN_DELETE_EMAIL_SUCCESS = '/admin/DELETE_EMAIL_SUCCESS'
export const ADMIN_CREATE_EMAIL_PENDING = '/admin/CREATE_EMAIL_PENDING'
export const ADMIN_CREATE_EMAIL_SUCCESS = '/admin/CREATE_EMAIL_SUCCESS'
export const ADMIN_TOGGLE_EMAIL_MODAL = '/admin/TOGGLE_EMAIL_MODAL'
export const ADMIN_UPDATE_EMAIL_FIELD_VALUE = '/admin/UPDATE_EMAIL_FIELD_VALUE'
export const ADMIN_UPDATE_EMAIL_SUBJECT_VALUE = '/admin/UPDATE_EMAIL_SUBJECT_VALUE'
export const ADMIN_ADD_TEMPLATE_RICH_EDITOR = '/admin/ADMIN_ADD_TEMPLATE_RICH_EDITOR'
export const ADMIN_SEND_EMAIL_PENDING = '/admin/SEND_EMAIL_PENDING'
export const ADMIN_SEND_EMAIL_SUCCESS = '/admin/SEND_EMAIL_SUCCESS'
export const ADMIN_CREATE_PDF_PENDING = '/admin/CREATE_PDF_PENDING'
export const ADMIN_CREATE_PDF_SUCCESS = '/admin/CREATE_PDF_SUCCESS'
export const ADMIN_SEND_POST_PENDING = '/admin/SEND_POST_PENDING'
export const ADMIN_SEND_POST_SUCCESS = '/admin/SEND_POST_SUCCESS'
export const ADMIN_GET_ACTIONS_PENDING = '/admin/GET_ACTIONS_PENDING'
export const ADMIN_GET_ACTIONS_SUCCESS = '/admin/GET_ACTIONS_SUCCESS'
export const MANUAL_PENDING = '/admin/MANUAL_PENDING'
export const MANUAL_SUCCESS = '/admin/MANUAL_SUCCESS'
export const ADMIN_GET_REASONS_PENDING = '/admin/GET_REASONS_PENDING'
export const ADMIN_GET_REASONS_SUCCESS = '/admin/GET_REASONS_SUCCESS'
export const ADMIN_GET_REASON_PENDING = '/admin/GET_REASON_PENDING'
export const ADMIN_GET_REASON_SUCCESS = '/admin/GET_REASON_SUCCESS'
export const ADMIN_UPDATE_REASON_PENDING = '/admin/UPDATE_REASON_PENDING'
export const ADMIN_UPDATE_REASON_SUCCESS = '/admin/UPDATE_REASON_SUCCESS'
export const ADMIN_DELETE_REASON_PENDING = '/admin/DELETE_REASON_PENDING'
export const ADMIN_DELETE_REASON_SUCCESS = '/admin/DELETE_REASON_SUCCESS'
export const ADMIN_CREATE_REASON_PENDING = '/admin/CREATE_REASON_PENDING'
export const ADMIN_CREATE_REASON_SUCCESS = '/admin/CREATE_REASON_SUCCESS'
export const CLEAR_RICH_FIELD_PENDING = '/admin/CLEAR_RICH_FIELD_PENDING'
export const CLEAR_RICH_FIELD_SUCCESS = '/admin/CLEAR_RICH_FIELD_SUCCESS'
const cookies = new Cookies()

export const loginLink = (e) => (dispatch) => {
  dispatch({
    type: ADMIN_LOGIN_PENDING
  })
  const data = {
    email: helpers.formatEmail(e.target.email.value)
  }

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }

  fetch(`${API_URL}/admin/login`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          dispatch({
            type: ADMIN_AUTH_SUCCESS
          })
          toastPush(res.success, 'success')
          return
        }
        // Response not OK
        dispatch({
          type: ADMIN_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')
      }, () => {
        dispatch({
          type: ADMIN_FAIL,
          error: SERVER_ERROR
        })
        toastPush(SERVER_ERROR, 'error')
      })
    },
    // Server Error
    () => {
      dispatch({
        type: ADMIN_FAIL,
        error: SERVER_ERROR
      })
      toastPush(SERVER_ERROR, 'error')
    })
}

export const checkAdminToken = (accessToken) => (dispatch) => {
  dispatch({
    type: ADMIN_AUTH_PENDING
  })

  let data = { access_token: accessToken }
  if (!cookies.get('ps_admin_tfa')) {
    data.send_pin = true
  }
  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }

  fetch(`${API_URL}/admin/auth`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          cookies.set('ps_admin_access_token', accessToken, { path: '/' })
          var decoded = jwtDecode(res.token)

          dispatch({
            type: ADMIN_AUTH_SUCCESS,
            item: res.item,
            token: res.token,
            pin: decoded.pin
          })

          if (!cookies.get('ps_admin_tfa')) {
            dispatch(push('/admin/pin'))
            return
          }

          return
        }

        dispatch({
          type: ADMIN_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')

        cookies.remove('ps_admin_access_token', { path: '/' })
        dispatch(push('/admin/login'))
      }, () => {
        dispatch({
          type: ADMIN_FAIL,
          error: SERVER_ERROR
        })
        toastPush(SERVER_ERROR, 'error')
      })
    }, () => {
      dispatch({
        type: ADMIN_FAIL,
        error: SERVER_ERROR
      })
      toastPush(SERVER_ERROR, 'error')
      dispatch(push('/admin/login'))
    }

    )
}

export const checkAdminTokenRedirect = (accessToken) => (dispatch) => {
  dispatch({
    type: ADMIN_AUTH_PENDING
  })

  const data = { access_token: accessToken }

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }

  fetch(`${API_URL}/admin/auth`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          cookies.set('ps_admin_access_token', accessToken, { path: '/' })
          dispatch({
            type: ADMIN_AUTH_SUCCESS,
            data: res
          })
          dispatch(push('/admin'))
          return
        }

        dispatch({
          type: ADMIN_FAIL,
          error: res.error
        })
        cookies.remove('ps_admin_access_token', { path: '/' })
      }, () => {
        dispatch({
          type: ADMIN_FAIL,
          error: SERVER_ERROR
        })
        toastPush(SERVER_ERROR, 'error')
      })
    }, () => {
      dispatch({
        type: ADMIN_FAIL,
        error: SERVER_ERROR
      })
      toastPush(SERVER_ERROR, 'error')
    }

    )
}

export const getAdminUsers = () => (dispatch) => {
  dispatch({
    type: ADMIN_GET_USERS_PENDING
  })
  const fetchOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().admin.token
    }
  }

  fetch(`${API_URL}/admin/users`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          dispatch({
            type: ADMIN_GET_USERS_SUCCESS,
            data: res
          })

          return
        }
        if (res.auth === false) {
          dispatch(tokenLogOut(res.message))
        }
        dispatch({
          type: ADMIN_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')
      })
    }, () => {
      dispatch({
        type: ADMIN_FAIL,
        error: SERVER_ERROR
      })
    }

    )
}

export const getUser = (email) => (dispatch) => {
  dispatch({
    type: ADMIN_GET_USER_PENDING
  })
  const fetchOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().admin.token
    }
  }

  fetch(`${API_URL}/admin/users/${email}`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          dispatch({
            type: ADMIN_GET_USER_SUCCESS,
            data: res
          })

          return
        }
        if (res.auth === false) {
          dispatch(tokenLogOut(res.message))
        }
        dispatch({
          type: ADMIN_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')
      })
    }, () => {
      dispatch({
        type: ADMIN_FAIL,
        error: SERVER_ERROR
      })
    }

    )
}

export const updateUser = (e) => (dispatch) => {
  dispatch({
    type: ADMIN_UPDATE_USER_PENDING
  })
  const data = {
    email: helpers.formatEmail(e.target.email.value),
    first_name: e.target.first_name.value,
    last_name: e.target.last_name.value,
    mobile: e.target.mobile.value,
    access_token: e.target.access_token.value
  }

  const fetchOptions = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().admin.token
    },
    body: JSON.stringify(data)
  }

  fetch(`${API_URL}/admin/users/${data.email}`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          dispatch({
            type: ADMIN_UPDATE_USER_SUCCESS
          })
          toastPush('User updated', 'success')
          dispatch(push('/admin/users'))
          return
        }
        if (res.auth === false) {
          dispatch(tokenLogOut(res.message))
        }
        // Response not OK
        dispatch({
          type: ADMIN_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')
      }, () => {
        dispatch({
          type: ADMIN_FAIL,
          error: SERVER_ERROR
        })
        toastPush(SERVER_ERROR, 'error')
      })
    },
    // Server Error
    () => {
      dispatch({
        type: ADMIN_FAIL,
        error: SERVER_ERROR
      })
      toastPush(SERVER_ERROR, 'error')
    })
}

export const createUser = (e) => (dispatch) => {
  dispatch({
    type: ADMIN_CREATE_USER_PENDING
  })
  const data = {
    email: helpers.formatEmail(e.target.email.value),
    first_name: e.target.first_name.value,
    last_name: e.target.last_name.value,
    mobile: e.target.mobile.value
  }

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().admin.token
    },
    body: JSON.stringify(data)
  }

  fetch(`${API_URL}/admin/users`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          dispatch({
            type: ADMIN_CREATE_USER_SUCCESS
          })
          toastPush('Created user', 'success')
          dispatch(push('/admin/users'))
          return
        }
        if (res.auth === false) {
          dispatch(tokenLogOut(res.message))
        }
        // Response not OK
        dispatch({
          type: ADMIN_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')
      }, () => {
        dispatch({
          type: ADMIN_FAIL,
          error: SERVER_ERROR
        })
        toastPush(SERVER_ERROR, 'error')
      })
    },
    // Server Error
    () => {
      dispatch({
        type: ADMIN_FAIL,
        error: SERVER_ERROR
      })
      toastPush(SERVER_ERROR, 'error')
    })
}

export const deleteUser = (email) => (dispatch) => {
  let r = true
  r = window.confirm('Are you sure you want to delete?')
  if (r === false) return
  dispatch({
    type: ADMIN_DELETE_USER_PENDING
  })
  const data = {
    email: email
  }

  const fetchOptions = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().admin.token
    },
    body: JSON.stringify(data)
  }

  fetch(`${API_URL}/admin/users/${email}`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          dispatch({
            type: ADMIN_DELETE_USER_SUCCESS
          })
          toastPush(res.success, 'success')
          dispatch(push('/admin/users'))
          return
        }
        if (res.auth === false) {
          dispatch(tokenLogOut(res.message))
        }
        // Response not OK
        dispatch({
          type: ADMIN_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')
      }, () => {
        dispatch({
          type: ADMIN_FAIL,
          error: SERVER_ERROR
        })
        toastPush(SERVER_ERROR, 'error')
      })
    },
    // Server Error
    () => {
      dispatch({
        type: ADMIN_FAIL,
        error: SERVER_ERROR
      })
      toastPush(SERVER_ERROR, 'error')
    })
}

export const getAppeals = () => (dispatch) => {
  dispatch({
    type: ADMIN_GET_APPEALS_PENDING
  })
  const fetchOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().admin.token
    }
  }

  fetch(`${API_URL}/admin/appeals`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          dispatch({
            type: ADMIN_GET_APPEALS_SUCCESS,
            data: res
          })

          return
        }
        if (res.auth === false) {
          dispatch(tokenLogOut(res.message))
        }

        dispatch({
          type: ADMIN_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')
      })
    }, () => {
      dispatch({
        type: ADMIN_FAIL,
        error: SERVER_ERROR
      })
    }

    )
}

export const getAppeal = (appealID) => (dispatch) => {
  dispatch({
    type: ADMIN_GET_APPEAL_PENDING
  })
  const fetchOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().admin.token
    }
  }

  fetch(`${API_URL}/admin/appeals/${appealID}`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          // get the original index values for deletion
          // res.replies.values.forEach(function (reply, index) {
          //   let obj = JSON.parse(reply)
          //   obj.index = index
          //   reply = JSON.stringify(obj)
          //   res.replies.values[index] = reply
          // })

          dispatch({
            type: ADMIN_GET_APPEAL_SUCCESS,
            data: res
          })

          return
        }

        if (res.auth === false) {
          dispatch(tokenLogOut(res.message))
        }

        dispatch({
          type: ADMIN_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')
      })
    }, () => {
      dispatch({
        type: ADMIN_FAIL,
        error: SERVER_ERROR
      })
    }

    )
}

export const toastPush = (msg, type = 'success') => {
  if (type === 'error') {
    toast.error(msg, { autoClose: 3000, hideProgressBar: true })
  } else {
    toast.success(msg, { autoClose: 3000, hideProgressBar: true })
  }
}

export const logOut = () => (dispatch) => {
  cookies.remove('ps_admin_access_token', { path: '/' })
  cookies.remove('ps_admin_tfa', { path: '/' })
  dispatch(push('/admin/login'))
}

const tokenLogOut = (msg) => (dispatch) => {
  cookies.remove('ps_admin_access_token', { path: '/' })
  cookies.remove('ps_admin_access_token', { path: '/' })
  toastPush('Your session token is invalid or has expired, please login again. Error: ' + msg, 'error')
  dispatch(push('/admin/login'))
}

export const pinError = () => () => {
  toastPush('Code does not match. Please try again', 'error')
}

export const saveForm = (e) => (dispatch) => {
  let f = e.target
  const id = e.target.id
  dispatch({
    type: ADMIN_UPDATE_APPEAL_PENDING,
    id
  })

  let data = {}
  // Extract Each Element Value
  for (var i = 0; i < f.elements.length; i++) {
    if (f.elements[i].name) {
      if (f.elements[i].type === 'radio') {
        if (f.elements[i].checked) {
          data[f.elements[i].name] = f.elements[i].value
        }
      } else {
        if (f.elements[i].value) {
          data[f.elements[i].name] = f.elements[i].value
        }
      }
    }
  }

  if (!data.email) {
    data.email = null
  }
  if (!data.address2) {
    data.address2 = null
  }
  var merged = {
    ...store.getState().admin.appeal,
    ...data
  }

  console.log(merged)

  // format reg
  merged.reg = helpers.formatReg(merged.reg)

  switch (id) {
    case 'details':
      merged.completed_driver_details = true
      break
    case 'grounds':
      merged.completed_appeal_grounds = true
      break
    case 'appealDetail':
      merged.completed_appeal_detail = true
      break

    default:
      break
  }

  if (merged.date) {
    merged.submitby = moment(merged.date, 'YYYY-MM-DD').add(21, 'days')
  }

  delete merged.uuid

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().admin.token
    },
    body: JSON.stringify(merged)
  }

  fetch(`${API_URL}/appeals`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          dispatch({
            type: ADMIN_UPDATE_APPEAL_SUCCESS,
            data: merged,
            id
          })
          dispatch(addActivity(merged.appealID, `Adjudicator updated appeal on behalf of client.`))

          toastPush('Saved', 'success')

          return
        }
        if (res.auth === false) {
          dispatch(tokenLogOut(res.message))
        }
        dispatch({
          type: ADMIN_UPDATE_APPEAL_FAIL,
          error: res.error,
          id
        })
        toastPush(res.error, 'error')
      })
    }, (error) => {
      console.log(error)
      dispatch({
        type: ADMIN_UPDATE_APPEAL_FAIL,
        error: SERVER_ERROR
      })
      toastPush(SERVER_ERROR, 'error')
    }

    )
}

export const getResponses = () => (dispatch) => {
  dispatch({
    type: ADMIN_GET_RESPONSES_PENDING
  })
  const fetchOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().admin.token
    }
  }

  fetch(`${API_URL}/admin/responses`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          dispatch({
            type: ADMIN_GET_RESPONSES_SUCCESS,
            data: res
          })

          return
        }
        if (res.auth === false) {
          dispatch(tokenLogOut(res.message))
        }
        dispatch({
          type: ADMIN_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')
      })
    }, () => {
      dispatch({
        type: ADMIN_FAIL,
        error: SERVER_ERROR
      })
    }

    )
}

export const getResponse = (id) => (dispatch) => {
  dispatch({
    type: ADMIN_GET_RESPONSE_PENDING
  })
  const fetchOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().admin.token
    }
  }

  fetch(`${API_URL}/admin/responses/${id}`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          dispatch({
            type: ADMIN_GET_RESPONSE_SUCCESS,
            data: res
          })

          return
        }
        if (res.auth === false) {
          dispatch(tokenLogOut(res.message))
        }
        dispatch({
          type: ADMIN_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')
      })
    }, () => {
      dispatch({
        type: ADMIN_FAIL,
        error: SERVER_ERROR
      })
    }

    )
}

export const updateResponse = (e) => (dispatch) => {
  dispatch({
    type: ADMIN_UPDATE_RESPONSE_PENDING
  })
  const data = {
    name: e.target.name.value,
    response: e.target.response.value,
    category: e.target.category.value,
    pdf_template: e.target.pdf_template.value,
    type: e.target.type.value,
    time_limit_template: e.target.time_limit_template.value,
    time_limit: e.target.time_limit.value,
    time_limit_status: e.target.time_limit_status.value,
    show_payment_details: e.target.show_payment_details.value,
    payment_amount: e.target.payment_amount.value,
    after_reply_status: e.target.after_reply_status.value,
    id: e.target.id.value
  }

  console.log(data)

  const fetchOptions = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().admin.token
    },
    body: JSON.stringify(data)
  }

  fetch(`${API_URL}/admin/responses/${data.id}`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          dispatch({
            type: ADMIN_UPDATE_RESPONSE_SUCCESS
          })
          toastPush('Response updated', 'success')
          dispatch(push('/admin/responses'))
          return
        }
        if (res.auth === false) {
          dispatch(tokenLogOut(res.message))
        }
        // Response not OK
        dispatch({
          type: ADMIN_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')
      }, () => {
        dispatch({
          type: ADMIN_FAIL,
          error: SERVER_ERROR
        })
        toastPush(SERVER_ERROR, 'error')
      })
    },
    // Server Error
    () => {
      dispatch({
        type: ADMIN_FAIL,
        error: SERVER_ERROR
      })
      toastPush(SERVER_ERROR, 'error')
    })
}

export const createResponse = (e) => (dispatch) => {
  dispatch({
    type: ADMIN_CREATE_RESPONSE_PENDING
  })
  const data = {
    name: e.target.name.value,
    response: e.target.response.value,
    category: e.target.category.value,
    pdf_template: e.target.pdf_template.value,
    type: e.target.type.value,
    time_limit_template: e.target.time_limit_template.value,
    time_limit: e.target.time_limit.value,
    time_limit_status: e.target.time_limit_status.value,
    show_payment_details: e.target.show_payment_details.value,
    payment_amount: e.target.payment_amount.value,
    after_reply_status: e.target.after_reply_status.value
  }

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().admin.token
    },
    body: JSON.stringify(data)
  }

  fetch(`${API_URL}/admin/responses`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          dispatch({
            type: ADMIN_CREATE_RESPONSE_SUCCESS
          })
          toastPush('Created response', 'success')
          dispatch(push('/admin/responses'))
          return
        }
        if (res.auth === false) {
          dispatch(tokenLogOut(res.message))
        }
        // Response not OK
        dispatch({
          type: ADMIN_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')
      }, () => {
        dispatch({
          type: ADMIN_FAIL,
          error: SERVER_ERROR
        })
        toastPush(SERVER_ERROR, 'error')
      })
    },
    // Server Error
    () => {
      dispatch({
        type: ADMIN_FAIL,
        error: SERVER_ERROR
      })
      toastPush(SERVER_ERROR, 'error')
    })
}

export const deleteResponse = (id) => (dispatch) => {
  let r = true
  r = window.confirm('Are you sure you want to delete?')
  if (r === false) return
  dispatch({
    type: ADMIN_DELETE_RESPONSE_PENDING
  })
  const data = {
    id: id
  }

  const fetchOptions = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().admin.token
    },
    body: JSON.stringify(data)
  }

  fetch(`${API_URL}/admin/responses/${id}`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          dispatch({
            type: ADMIN_DELETE_RESPONSE_SUCCESS
          })
          toastPush(res.success, 'success')
          dispatch(push('/admin/responses'))
          return
        }
        if (res.auth === false) {
          dispatch(tokenLogOut(res.message))
        }
        // Response not OK
        dispatch({
          type: ADMIN_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')
      }, () => {
        dispatch({
          type: ADMIN_FAIL,
          error: SERVER_ERROR
        })
        toastPush(SERVER_ERROR, 'error')
      })
    },
    // Server Error
    () => {
      dispatch({
        type: ADMIN_FAIL,
        error: SERVER_ERROR
      })
      toastPush(SERVER_ERROR, 'error')
    })
}

export const createAdminReply = (options, file = null) => (dispatch) => {
  dispatch({
    type: ADMIN_CREATE_REPLY_PENDING
  })

  const adjudicator = `${store.getState().admin.auth.first_name} ${store.getState().admin.auth.last_name}`
  const appellant = store.getState().admin.appeal.fname ? `${store.getState().admin.appeal.fname} ${store.getState().admin.appeal.lname}` : `Appellant`
  const email = store.getState().admin.appeal.email
  let data = {
    reply: store.getState().admin.emailValue,
    user: 'adjudicator',
    adjudicator,
    appellant,
    email,
    showPaymentDetails: options ? options.showPaymentDetail : false,
    paymentAmount: options ? options.paymentAmount : 0

  }

  if (file && ['image/png', 'image/jpeg', 'image/gif'].includes(file.mime)) {
    data.reply = `Image uploaded:<br /> <a target='_blank' href='${file.url}'><img class='img-fluid' src='${file.url}' /></a>`
  }

  if (file && !['image/png', 'image/jpeg', 'image/gif'].includes(file.mime)) {
    data.reply = `Document uploaded:<br /> <a target='_blank' href='${file.url}'>${file.name}</a>`
  }

  const id = store.getState().admin.appeal.appealID
  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().admin.token
    },
    body: JSON.stringify(data)
  }

  fetch(`${API_URL}/replies/${id}`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          dispatch({
            type: ADMIN_CREATE_REPLY_SUCCESS,
            reply: res.data
          })
          toastPush('Message sent', 'success')
          dispatch({
            type: '/admin/TOGGLE_REPLY_MODAL',
            value: false
          })

          if (options && options.afterReplyStatus) {
            dispatch(setStatusQuiet(id, options.afterReplyStatus))
          } else {
            dispatch(setStatusQuiet(id, 'pending appellant response'))
          }
          dispatch(addActivity(id, `Message sent to appellant`))
          // set an autoresponder
          if (options && options.timeLimit > 0) {
            dispatch(addAutoResponder(id, options.timeLimit, options.timeLimitStatus, options.timeLimitTemplate))
          }

          dispatch(getAppeal(id))

          return
        }
        if (res.auth === false) {
          dispatch(tokenLogOut(res.message))
        }
        // Response not OK
        dispatch({
          type: ADMIN_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')
      }, () => {
        dispatch({
          type: ADMIN_FAIL,
          error: SERVER_ERROR
        })
        toastPush(SERVER_ERROR, 'error')
      })
    },
    // Server Error
    () => {
      dispatch({
        type: ADMIN_FAIL,
        error: SERVER_ERROR
      })
      toastPush(SERVER_ERROR, 'error')
    })
}

export const sendEmail = (e) => (dispatch) => {
  dispatch({
    type: ADMIN_SEND_EMAIL_PENDING
  })

  const adjudicator = `${store.getState().admin.auth.first_name} ${store.getState().admin.auth.last_name}`
  const appellant = store.getState().admin.appeal.fname ? `${store.getState().admin.appeal.fname} ${store.getState().admin.appeal.lname}` : `Appellant`

  const data = {
    body: e.target.emailcontent.value,
    adjudicator,
    appellant,
    email: e.target.email.value,
    subject: e.target.subject.value
  }

  console.log(data)
  const id = e.target.appealID.value
  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().admin.token
    },
    body: JSON.stringify(data)
  }

  fetch(`${API_URL}/email/${id}`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          dispatch({
            type: ADMIN_SEND_EMAIL_SUCCESS
          })
          dispatch(addActivity(id, `Email sent to: ${data.email} - ${data.subject}`))
          toastPush('Email sent', 'success')
          return
        }
        if (res.auth === false) {
          dispatch(tokenLogOut(res.message))
        }
        // Response not OK
        dispatch({
          type: ADMIN_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')
      }, () => {
        dispatch({
          type: ADMIN_FAIL,
          error: SERVER_ERROR
        })
        toastPush(SERVER_ERROR, 'error')
      })
    },
    // Server Error
    () => {
      dispatch({
        type: ADMIN_FAIL,
        error: SERVER_ERROR
      })
      toastPush(SERVER_ERROR, 'error')
    })
}

export const addTemplateResponse = (response) => (dispatch) => {
  const adjudicator = `${store.getState().admin.auth.first_name} ${store.getState().admin.auth.last_name}`
  const appellant = store.getState().admin.appeal.fname ? `${store.getState().admin.appeal.fname} ${store.getState().admin.appeal.lname}` : `Appellant`
  const reg = store.getState().admin.appeal.reg
  const pcn = store.getState().admin.appeal.pcn
  const issuedate = moment(store.getState().admin.appeal.date).format('DD/MM/YYYY')
  const date = moment().format('DD/MM/YYYY')

  response = response.replace(/%adjudicator%/g, adjudicator)
  response = response.replace(/%appellant%/g, appellant)
  response = response.replace(/%pcn%/g, pcn)
  response = response.replace(/%reg%/g, reg)
  response = response.replace(/%issuedate%/g, issuedate)
  response = response.replace(/%date%/g, date)

  dispatch({
    type: ADMIN_ADD_TEMPLATE_RICH_EDITOR,
    value: response
  })

  dispatch({
    type: ADMIN_TOGGLE_RESPONSE_MODAL
  })
}

export const setStatus = (status, confirm = false) => (dispatch) => {
  if (confirm) {
    let r = true
    r = window.confirm(`Are you sure you want to change status to ${status}?`)
    if (r === false) return
  }

  if (status === 'breach') {
    let b = true
    b = window.confirm(`Changing this appeal to breach with add a suffic of -b to PCN and user can no longer login to view. Is this ok?`)
    if (b === false) return
  }
  dispatch({
    type: ADMIN_UPDATE_STATUS_PENDING
  })

  var data = store.getState().admin.appeal
  data.status = status

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().admin.token
    },
    body: JSON.stringify(data)
  }

  fetch(`${API_URL}/appeals`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          dispatch({
            type: ADMIN_UPDATE_STATUS_SUCCESS
          })
          dispatch(addActivity(data.appealID, `Status changed to: ${status}`))
          toastPush(`Status changed to ${status}`, 'success')
          if (data.status === 'accepted' || data.status === 'rejected') {
            dispatch(setCompletionDate(data.appealID))
          }
          if (data.status === 'breach') {
            dispatch(breach(data.appealID, data.pcn))
          }
          return
        }
        if (res.auth === false) {
          dispatch(tokenLogOut(res.message))
        }
        dispatch({
          type: ADMIN_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')
      })
    }, (error) => {
      console.log(error)
      dispatch({
        type: ADMIN_FAIL,
        error: SERVER_ERROR
      })
      toastPush(SERVER_ERROR, 'error')
    }

    )
}

export const setStatusQuiet = (appealID, status) => (dispatch) => {
  let data = { status }

  const fetchOptions = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().admin.token
    },
    body: JSON.stringify(data)
  }

  fetch(`${API_URL}/status/${appealID}`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          dispatch(addActivity(appealID, `Status changed to: ${data.status}`))
          dispatch(getAppeal(appealID))
          if (data.status === 'accepted' || data.status === 'rejected') {
            dispatch(setCompletionDate(appealID))
          }
        }
      })
    }
    )
}

export const setCompletionDate = (appealID) => (dispatch) => {
  const fetchOptions = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().admin.token
    }
  }
  fetch(`${API_URL}/completion/${appealID}`, fetchOptions)
}

export const breach = (appealID, pcn) => (dispatch) => {
  const fetchOptions = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().admin.token
    }
  }
  fetch(`${API_URL}/breach/${appealID}/${pcn}`, fetchOptions).then(function () {
    dispatch(push('/admin'))
  })
}

export const createPdf = (template) => (dispatch) => {
  dispatch({
    type: ADMIN_CREATE_PDF_PENDING
  })

  const adjudicator = `${store.getState().admin.auth.first_name} ${store.getState().admin.auth.last_name}`
  const appellant = store.getState().admin.appeal.fname ? `${store.getState().admin.appeal.fname} ${store.getState().admin.appeal.lname}` : `Appellant`

  const data = {
    body: store.getState().admin.emailValue,
    subject: store.getState().admin.subjectValue,
    address_name: `${store.getState().admin.appeal.fname} ${store.getState().admin.appeal.lname}`,
    address_line_1: store.getState().admin.appeal.address1,
    address_line_2: store.getState().admin.appeal.address2,
    address_city: store.getState().admin.appeal.town,
    address_state: store.getState().admin.appeal.county,
    address_postal_code: store.getState().admin.appeal.postcode,
    adjudicator,
    appellant,
    template
  }

  const appealID = store.getState().admin.appeal.appealID

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().admin.token
    },
    body: JSON.stringify(data)
  }

  fetch(`${API_URL}/pdf/${appealID}`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (!res.success) {
          toastPush(res.error, 'error')
          dispatch({
            type: ADMIN_FAIL,
            error: SERVER_ERROR
          })
          return
        }

        dispatch({
          type: ADMIN_CREATE_PDF_SUCCESS,
          pdf: res.pdf
        })
        dispatch(push(`/admin/appeal/${appealID}/pdf/`))
      }, () => {
        dispatch({
          type: ADMIN_FAIL,
          error: SERVER_ERROR
        })
        toastPush(SERVER_ERROR, 'error')
      })
    },
    // Server Error
    () => {
      dispatch({
        type: ADMIN_FAIL,
        error: SERVER_ERROR
      })
      toastPush(SERVER_ERROR, 'error')
    })
}

export const sendPost = () => (dispatch) => {
  let r = true
  r = window.confirm(`Are you sure you want to post this letter?`)
  if (r === false) return
  dispatch({
    type: ADMIN_SEND_POST_PENDING
  })

  if (!store.getState().admin.appeal.fname || !store.getState().admin.appeal.address1) {
    toastPush('Appellants address details are not complete.', 'error')
    return
  }
  const appealID = store.getState().admin.appeal.appealID
  const pdf = store.getState().admin.pdf
  const adjudicator = `${store.getState().admin.auth.first_name} ${store.getState().admin.auth.last_name}`
  const appellant = store.getState().admin.appeal.fname ? `${store.getState().admin.appeal.fname} ${store.getState().admin.appeal.lname}` : `Appellant`

  const data = {
    pdf, adjudicator, appellant
  }

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().admin.token
    },
    body: JSON.stringify(data)
  }

  fetch(`${API_URL}/post/${appealID}`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          dispatch({
            type: ADMIN_SEND_POST_SUCCESS,
            data: res
          })
          toastPush('Letter has been posted', 'success')
          dispatch(addActivity(appealID, `Physical letter sent`, pdf))
          dispatch(push(`/admin/appeal/${appealID}/messaging`))
          dispatch({
            type: CLEAR_RICH_FIELD_PENDING
          })
          return
        }
        dispatch({
          type: ADMIN_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')
      }, (error) => {
        dispatch({
          type: ADMIN_FAIL,
          error: error
        })
        toastPush(error, 'error')
      })
    },
    // Server Error
    (error) => {
      dispatch({
        type: ADMIN_FAIL,
        error: error
      })
      toastPush(SERVER_ERROR, 'error')
    })
}

export const addActivity = (appealID, activity, url = null) => (dispatch) => {
  let data = {
    activity,
    url
  }

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().admin.token
    },
    body: JSON.stringify(data)
  }

  fetch(`${API_URL}/activity/${appealID}`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          dispatch(getActions(appealID))
        }
      })
    }
    )
}

export const getActions = (appealID) => (dispatch) => {
  dispatch({
    type: ADMIN_GET_ACTIONS_PENDING
  })
  const fetchOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().admin.token
    }
  }

  fetch(`${API_URL}/admin/actions/${appealID}`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          dispatch({
            type: ADMIN_GET_ACTIONS_SUCCESS,
            data: res
          })

          return
        }
        if (res.auth === false) {
          dispatch(tokenLogOut(res.message))
        }
        dispatch({
          type: ADMIN_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')
      })
    }, () => {
      dispatch({
        type: ADMIN_FAIL,
        error: SERVER_ERROR
      })
    }

    )
}

export const manualAppeal = (e) => (dispatch) => {
  const data = {
    pcn: helpers.formatPCN(e.target.pcn.value),
    reg: helpers.formatReg(e.target.reg.value),
    email: helpers.formatEmail(e.target.email.value),
    date: e.target.date.value,
    status: 'registered',
    manual: true,
    submitby: moment(e.target.date.value, 'YYYY-MM-DD').add(21, 'days')
  }

  dispatch({
    type: MANUAL_PENDING,
    data
  })

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().admin.token
    },
    body: JSON.stringify(data)
  }

  fetch(`${API_URL}/appeals/register`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          dispatch({
            type: MANUAL_SUCCESS
          })
          dispatch(push('/admin'))
          return
        }
        if (res.auth === false) {
          dispatch(tokenLogOut(res.message))
        }
        dispatch({
          type: ADMIN_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')
      })
    }, () => {
      dispatch({
        type: ADMIN_FAIL,
        error: SERVER_ERROR
      })
      toastPush(SERVER_ERROR, 'error')
    }

    )
}

export const fileUploadFinish = (file, s3url, appealID, type) => (dispatch) => {
  const data = {
    name: file.name,
    url: s3url,
    size: file.size,
    type
  }

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().admin.token
    },
    body: JSON.stringify(data)
  }

  fetch(`${API_URL}/admin/uploadFinish/${appealID}`, fetchOptions)
    .then((response) => {
      console.log(response)
      response.json().then((res) => {
        if (response.ok) {
          dispatch({
            type: ADMIN_UPLOAD_FILE_SUCCESS
          })
          dispatch(addActivity(appealID, `Admin uploaded ${data.type} file: ${data.name}`))
          toastPush('Uploaded', 'success')
          dispatch(getAppeal(appealID))
          return
        }
        if (res.auth === false) {
          dispatch(tokenLogOut(res.message))
        }
        dispatch({
          type: ADMIN_UPLOAD_FILE_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')
      })
    }, (error) => {
      console.log('response bad')
      console.log(error)
      dispatch({
        type: ADMIN_UPLOAD_FILE_FAIL,
        error: SERVER_ERROR
      })
      toastPush(SERVER_ERROR, 'error')
    }

    )
}

export const fileUploadFinishChat = (file, s3url, appealID, type) => (dispatch) => {
  const data = {
    name: file.name,
    url: s3url,
    size: file.size,
    type,
    mime: file.type
  }

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().admin.token
    },
    body: JSON.stringify(data)
  }

  fetch(`${API_URL}/admin/uploadFinish/${appealID}`, fetchOptions)
    .then((response) => {
      console.log(response)
      response.json().then((res) => {
        if (response.ok) {
          dispatch({
            type: ADMIN_UPLOAD_FILE_SUCCESS
          })
          dispatch(addActivity(appealID, `Admin uploaded ${data.type} file: ${data.name}`))
          toastPush('Uploaded', 'success')
          dispatch(createAdminReply(null, data))
          // dispatch(getAppeal(appealID))

          return
        }
        if (res.auth === false) {
          dispatch(tokenLogOut(res.message))
        }
        dispatch({
          type: ADMIN_UPLOAD_FILE_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')
      })
    }, (error) => {
      console.log('response bad')
      console.log(error)
      dispatch({
        type: ADMIN_UPLOAD_FILE_FAIL,
        error: SERVER_ERROR
      })
      toastPush(SERVER_ERROR, 'error')
    }

    )
}

export const getAdminReasons = () => (dispatch) => {
  dispatch({
    type: ADMIN_GET_REASONS_PENDING
  })
  const fetchOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().admin.token
    }
  }

  fetch(`${API_URL}/admin/reasons`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          dispatch({
            type: ADMIN_GET_REASONS_SUCCESS,
            data: res
          })

          return
        }
        if (res.auth === false) {
          dispatch(tokenLogOut(res.message))
        }
        dispatch({
          type: ADMIN_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')
      })
    }, () => {
      dispatch({
        type: ADMIN_FAIL,
        error: SERVER_ERROR
      })
    }

    )
}

export const getReason = (id) => (dispatch) => {
  dispatch({
    type: ADMIN_GET_REASON_PENDING
  })
  const fetchOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().admin.token
    }
  }

  fetch(`${API_URL}/admin/reasons/${id}`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          dispatch({
            type: ADMIN_GET_REASON_SUCCESS,
            data: res
          })

          return
        }
        if (res.auth === false) {
          dispatch(tokenLogOut(res.message))
        }
        dispatch({
          type: ADMIN_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')
      })
    }, () => {
      dispatch({
        type: ADMIN_FAIL,
        error: SERVER_ERROR
      })
    }

    )
}

export const updateReason = (e) => (dispatch) => {
  dispatch({
    type: ADMIN_UPDATE_REASON_PENDING
  })
  const data = {
    id: e.target.id.value,
    reason: e.target.reason.value,
    label: e.target.label.value
  }

  const fetchOptions = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().admin.token
    },
    body: JSON.stringify(data)
  }

  fetch(`${API_URL}/admin/reasons/${data.id}`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          dispatch({
            type: ADMIN_UPDATE_REASON_SUCCESS
          })
          toastPush('Reason updated', 'success')
          dispatch(push('/admin/reasons'))
          return
        }
        if (res.auth === false) {
          dispatch(tokenLogOut(res.message))
        }
        // Response not OK
        dispatch({
          type: ADMIN_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')
      }, () => {
        dispatch({
          type: ADMIN_FAIL,
          error: SERVER_ERROR
        })
        toastPush(SERVER_ERROR, 'error')
      })
    },
    // Server Error
    () => {
      dispatch({
        type: ADMIN_FAIL,
        error: SERVER_ERROR
      })
      toastPush(SERVER_ERROR, 'error')
    })
}

export const createReason = (e) => (dispatch) => {
  dispatch({
    type: ADMIN_CREATE_REASON_PENDING
  })
  const data = {
    reason: e.target.reason.value,
    label: e.target.reason.value.toLowerCase().replace(/\s/g, '')
  }

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().admin.token
    },
    body: JSON.stringify(data)
  }

  fetch(`${API_URL}/admin/reasons`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          dispatch({
            type: ADMIN_CREATE_REASON_SUCCESS
          })
          toastPush('Created reason', 'success')
          dispatch(push('/admin/reasons'))
          return
        }
        if (res.auth === false) {
          dispatch(tokenLogOut(res.message))
        }
        // Response not OK
        dispatch({
          type: ADMIN_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')
      }, () => {
        dispatch({
          type: ADMIN_FAIL,
          error: SERVER_ERROR
        })
        toastPush(SERVER_ERROR, 'error')
      })
    },
    // Server Error
    () => {
      dispatch({
        type: ADMIN_FAIL,
        error: SERVER_ERROR
      })
      toastPush(SERVER_ERROR, 'error')
    })
}

export const deleteReason = (id) => (dispatch) => {
  let r = true
  r = window.confirm('Warning - deleting a reason that has been used in an appeal will cause issues. Are you sure?')
  if (r === false) return
  dispatch({
    type: ADMIN_DELETE_REASON_PENDING
  })
  const data = {
    id: id
  }

  const fetchOptions = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().admin.token
    },
    body: JSON.stringify(data)
  }

  fetch(`${API_URL}/admin/reasons/${id}`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          dispatch({
            type: ADMIN_DELETE_REASON_SUCCESS
          })
          toastPush(res.success, 'success')
          dispatch(push('/admin/reasons'))
          return
        }
        if (res.auth === false) {
          dispatch(tokenLogOut(res.message))
        }
        // Response not OK
        dispatch({
          type: ADMIN_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')
      }, () => {
        dispatch({
          type: ADMIN_FAIL,
          error: SERVER_ERROR
        })
        toastPush(SERVER_ERROR, 'error')
      })
    },
    // Server Error
    () => {
      dispatch({
        type: ADMIN_FAIL,
        error: SERVER_ERROR
      })
      toastPush(SERVER_ERROR, 'error')
    })
}

export const clearRichField = () => (dispatch) => {
  dispatch({
    type: CLEAR_RICH_FIELD_PENDING
  })
}

export const clearRichFieldDone = () => (dispatch) => {
  dispatch({
    type: CLEAR_RICH_FIELD_SUCCESS
  })
}

export const addAutoResponder = (appealID, days, status, template) => (dispatch) => {
  console.log(appealID, days, status, template)

  if (!template) {
    toastPush('No autoresponder template chosen. Unable to set autoresponder.', 'error')
  }

  // get template
  const response = store.getState().admin.responses.filter(response => response.id === template)[0]

  const adjudicator = `${store.getState().admin.auth.first_name} ${store.getState().admin.auth.last_name}`
  const appellant = store.getState().admin.appeal.fname ? `${store.getState().admin.appeal.fname} ${store.getState().admin.appeal.lname}` : `Appellant`
  const reg = store.getState().admin.appeal.reg
  const pcn = store.getState().admin.appeal.pcn
  const issuedate = moment(store.getState().admin.appeal.date).format('DD/MM/YYYY')
  const email = store.getState().admin.appeal.email

  // find and replace variables
  let reply = response.response
  reply = reply.replace(/%adjudicator%/g, adjudicator)
  reply = reply.replace(/%appellant%/g, appellant)
  reply = reply.replace(/%pcn%/g, pcn)
  reply = reply.replace(/%reg%/g, reg)
  reply = reply.replace(/%issuedate%/g, issuedate)

  // create data to send to autoresponder end point
  let data = {
    appealID,
    expires: moment().endOf('day').add(days, 'days').toString(),
    reply,
    showPaymentDetails: response.show_payment_details,
    status,
    appellant,
    email,
    adjudicator,
    paymentAmount: response.payment_amount

  }

  console.log(data)

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().admin.token
    },
    body: JSON.stringify(data)
  }

  fetch(`${API_URL}/admin/autoresponder`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          toastPush(res.success, 'success')
          return
        }
        if (res.auth === false) {
          dispatch(tokenLogOut(res.message))
        }
        // Response not OK
        toastPush('Unable to set autoresponder', 'error')
      }, () => {
        toastPush('Unable to set autoresponder', 'error')
      })
    },
    // Server Error
    () => {
      toastPush('Unable to set autoresponder', 'error')
    })
}

export const previewPdf = (response, template) => (dispatch) => {
  dispatch({
    type: ADMIN_CREATE_PDF_PENDING
  })

  const adjudicator = 'Adam Adjudicator'
  const appellant = 'Anna Appellant'
  const pcn = '1234567910'
  const reg = 'AB16CD'
  const issuedate = moment().format('DD/MM/YYYY')

  response = response.replace(/%adjudicator%/g, adjudicator)
  response = response.replace(/%appellant%/g, appellant)
  response = response.replace(/%pcn%/g, pcn)
  response = response.replace(/%reg%/g, reg)
  response = response.replace(/%issuedate%/g, issuedate)
  response = response.replace(/%date%/g, issuedate)

  const data = {
    body: response,
    address_name: 'Anna Appellant',
    address_line_1: '123 Fake Street',
    address_line_2: null,
    address_city: 'Manchester',
    address_state: 'Greater Manchester',
    address_postal_code: 'M1 6HS',
    adjudicator,
    appellant,
    template
  }

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().admin.token
    },
    body: JSON.stringify(data)
  }

  fetch(`${API_URL}/pdf/preview`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (!res.success) {
          toastPush(res.error, 'error')
          dispatch({
            type: ADMIN_FAIL,
            error: SERVER_ERROR
          })
          return
        }
        dispatch({
          type: ADMIN_CREATE_PDF_SUCCESS
        })
        window.open(res.pdf, '_blank')
      }, () => {
        dispatch({
          type: ADMIN_FAIL,
          error: SERVER_ERROR
        })
        toastPush(SERVER_ERROR, 'error')
      })
    },
    // Server Error
    () => {
      dispatch({
        type: ADMIN_FAIL,
        error: SERVER_ERROR
      })
      toastPush(SERVER_ERROR, 'error')
    })
}

export const deleteAdminReply = (data) => (dispatch) => {
  const id = store.getState().admin.appeal.appealID
  const fetchOptions = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().admin.token
    },
    body: JSON.stringify(data)
  }

  fetch(`${API_URL}/replies/${id}`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          dispatch(getAppeal(id))
          toastPush(res.success, 'Deleted reply.')
          return
        }
        if (res.auth === false) {
          dispatch(tokenLogOut(res.message))
        }
        // Response not OK
        dispatch({
          type: ADMIN_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')
      }, () => {
        dispatch({
          type: ADMIN_FAIL,
          error: SERVER_ERROR
        })
        toastPush(SERVER_ERROR, 'error')
      })
    },
    // Server Error
    () => {
      dispatch({
        type: ADMIN_FAIL,
        error: SERVER_ERROR
      })
      toastPush(SERVER_ERROR, 'error')
    })
}



// WEBPACK FOOTER //
// ./src/actions/adminActions.js